import { useQuery } from '@apollo/client';
import { formatTimeRangeToISO } from '../../../../utils/dateTimeUtils';
import {
    GET_TMS_REPORT_LISTING,
    ReportFileType,
    TmsReportListResponse,
} from '../graphql/queries/getReportFileListingForTms';

export interface ReportFileFiltersType {
    type?: number;
    name?: string;
    reportDate?: [string | null, string | null] | null;
}

export interface ReportQueryResult {
    reportFileData: ReportFileType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useCentralReportFileQuery = (
    filters: ReportFileFiltersType,
    currentPage: number,
    pageSize: number,
    warehouseId?: number,
    skip: boolean = false
): ReportQueryResult => {
    const buildQueryVariables = () => {
        const timeRanges = {
            reportDate: formatTimeRangeToISO(filters.reportDate),
        };

        const queryFilters = {
            ...filters,
            ...timeRanges,
        };

        return {
            warehouseId,
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: 'createdAt',
                sortDirection: 'DESC',
            },
        };
    };

    const { data, loading: queryLoading, refetch } = useQuery<TmsReportListResponse>(GET_TMS_REPORT_LISTING, {
        variables: buildQueryVariables(),
        skip,
    });

    const reportFileData = data?.getReportFileListingForTms?.content || [];
    const totalElements = parseInt(data?.getReportFileListingForTms?.totalElements?.toString() || '0', 10) || 0;

    return {
        reportFileData,
        loading: skip || queryLoading,
        refetch,
        totalElements,
        buildQueryVariables,
    };
};

